import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    CustomTagsState,
    customTagsAdapter,
    CUSTOM_TAGS_FEATURE_KEY,
} from './custom-tags.reducer';

// Lookup the 'Custom Tags' feature state managed by NgRx
export const getCustomTagsState = createFeatureSelector<CustomTagsState>(
    CUSTOM_TAGS_FEATURE_KEY
);

const { selectAll, selectEntities } = customTagsAdapter.getSelectors();

export const getCustomTagsLoading = createSelector(
    getCustomTagsState,
    (state: CustomTagsState) => state.loading
);

export const getCustomTagsError = createSelector(
    getCustomTagsState,
    (state: CustomTagsState) => state.error
);

export const getSuggestions = createSelector(
    getCustomTagsState,
    (state: CustomTagsState) => state.suggestions
);

export const getAllCustomTags = createSelector(
    getCustomTagsState,
    (state: CustomTagsState) => {
        return selectAll(state);
    }
);

export const getCustomTagsEntities = createSelector(
    getCustomTagsState,
    (state: CustomTagsState) => selectEntities(state)
);

export const getCustomTags = createSelector(
    getCustomTagsState,
    (state: CustomTagsState) => state.entities
);

